import { channelKeys, getChannelKey } from "./channel.js";

const STORAGE_KEY = "PASSPORT_LAST_LOGIN_ENTRY";

const getChannelPrefix = (pathname) => {
  const match = (pathname || "").match(/^(\/[^/]+)?\/login(?:\/subAccount(?:\/[^/]+)?)?\/?$/);
  if (match && match[1]) return match[1];

  // MFA 页面不在渠道路由下，通过进入登录页时保存的 channel_key 恢复渠道前缀。
  const channelKey = getChannelKey();
  return channelKey ? `/${channelKey}` : "";
};

const setLastLoginEntry = (url) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, url);
  } catch (error) {}
};

// 历史入口只用于恢复主/子账号登录方式，不能携带上一次访问的业务参数。
// 兼容 localStorage 中已经存在的旧数据：子账号入口仅保留账号名，
// service、cid、营销参数等均由本次访问 URL 决定。
const sanitizeLoginEntry = (url) => {
  if (!url) return "";

  const questionMarkIndex = url.indexOf("?");
  const pathname = questionMarkIndex === -1 ? url : url.substring(0, questionMarkIndex);
  const search = questionMarkIndex === -1 ? "" : url.substring(questionMarkIndex + 1);
  const isMainAccountEntry = /^(\/[^/]+)?\/login\/?$/.test(pathname);
  const isSubAccountEntry = /^(\/[^/]+)?\/login\/subAccount\/[^/?]+\/?$/.test(pathname);

  if (!isMainAccountEntry && !isSubAccountEntry) return "";
  if (!isSubAccountEntry) return pathname;

  const subAccountName = new URLSearchParams(search).get("subAccountName");
  if (!subAccountName) return pathname;

  const params = new URLSearchParams();
  params.set("subAccountName", subAccountName);
  return `${pathname}?${params.toString()}`;
};

const getLastLoginEntry = () => {
  try {
    const url = window.localStorage.getItem(STORAGE_KEY) || "";
    return sanitizeLoginEntry(url);
  } catch (error) {
    return "";
  }
};

const recordMainAccountLoginEntry = () => {
  const channelPrefix = getChannelPrefix(window.location.pathname);
  setLastLoginEntry(`${channelPrefix}/login`);
};

const recordSubAccountLoginEntry = (SubAccountName, CompanyID) => {
  if (!SubAccountName || !CompanyID) return;

  const channelPrefix = getChannelPrefix(window.location.pathname);
  const params = new URLSearchParams();
  params.set("subAccountName", SubAccountName);
  const search = params.toString();
  const url = `${channelPrefix}/login/subAccount/${encodeURIComponent(CompanyID)}` +
    `${search ? `?${search}` : ""}`;
  setLastLoginEntry(url);
};

const recordPasswordMfaLoginEntry = (loginType, loginId) => {
  if (loginType === "Email") {
    recordMainAccountLoginEntry();
    return;
  }
  if (loginType !== "subAccount" || !loginId) return;

  const atIndex = loginId.lastIndexOf("@");
  if (atIndex <= 0 || atIndex === loginId.length - 1) return;
  recordSubAccountLoginEntry(
    loginId.substring(0, atIndex),
    loginId.substring(atIndex + 1)
  );
};

const isMainAccountLoginPage = () => {
  const pathname = window.location.pathname;
  const isLoginPath = /^(\/[^/]+)?\/login\/?$/.test(pathname);
  // services 项目在 API 返回 170/172/174 时会跳到 /?service=当前控制台地址。
  const isRootLogin = pathname === "/" && (
    window.location.hash.indexOf("#login") === 0 ||
    new URLSearchParams(window.location.search).has("service")
  );
  return isLoginPath || isRootLogin;
};

const hasChannelKeyInPath = (pathname) => {
  const channelKey = (pathname || "").split("/")[1];
  return Boolean(channelKey && channelKeys && channelKeys.split("|").includes(channelKey));
};

const mergeCurrentParams = (loginEntry) => {
  if (!loginEntry) return "";

  const currentParams = new URLSearchParams(window.location.search);
  if (!currentParams.toString()) return loginEntry;

  const questionMarkIndex = loginEntry.indexOf("?");
  const pathname = questionMarkIndex === -1 ? loginEntry : loginEntry.substring(0, questionMarkIndex);
  const search = questionMarkIndex === -1 ? "" : loginEntry.substring(questionMarkIndex + 1);
  const params = new URLSearchParams(search);
  // 本次访问参数属于显式输入，应覆盖历史入口中保存的同名参数。
  currentParams.forEach((value, key) => params.set(key, value));
  return `${pathname}?${params.toString()}`;
};

const hasExplicitEntryIntent = () => {
  const params = new URLSearchParams(window.location.search);
  const hash = window.location.hash || "";

  return (
    params.has("force_phone") ||
    params.has("cid") ||
    params.has("invitation_code") ||
    hash.indexOf("#inner-register") !== -1 ||
    hash.indexOf("email=") !== -1
  );
};

const restoreLastLoginEntry = () => {
  // 当前 URL 已明确指定渠道时，以本次访问入口为准，不使用历史登录入口覆盖。
  if (hasChannelKeyInPath(window.location.pathname)) return false;
  if (!isMainAccountLoginPage()) return false;

  // 本次访问明确指定了登录方式、集成方式或注册入口时，不使用隐藏的历史入口覆盖。
  if (hasExplicitEntryIntent()) return false;

  const lastLoginEntry = mergeCurrentParams(getLastLoginEntry());
  if (!lastLoginEntry || lastLoginEntry === `${window.location.pathname}${window.location.search}`) {
    return false;
  }

  window.location.replace(lastLoginEntry);
  return true;
};

export {
  getLastLoginEntry,
  recordMainAccountLoginEntry,
  recordPasswordMfaLoginEntry,
  recordSubAccountLoginEntry,
  restoreLastLoginEntry,
};



// WEBPACK FOOTER //
// ./src/common/loginEntry.js